export const TEST_IDS = {
  TWO_CLICK_APP_INSTALL_MPAC_FOCUSED_TASK: 'two-click-app-install-mpac-focused-task',
  INSTALLABLE_APP_PRIVACY_INFORMATION: 'installable-app-privacy-information',
  TWO_CLICK_APP_INSTALL_ERROR_BOUNDARY: 'two-click-app-install-error-boundary',
  PLAN_SELECTOR_TOOLTIP: 'plan-selector-tooltip',
  TWO_CLICK_PLAN_SELECTOR_ADVANCED_BOUGHT_SECTION_MESSAGE: 'two-click-plan-selector-advanced-bought-section-message',
  TWO_CLICK_PLAN_SELECTOR_STANDARD_BOUGHT_SECTION_MESSAGE: 'two-click-plan-selector-standard-bought-section-message',
  TWO_CLICK_MULTI_INSTANCE_PRICING_SECTION_MESSAGE: 'two-click-multi-instance-pricing-section-message'
};